import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import TextInput from 'src/modules/shared/components/atoms/inputs/text-input';
import type { ComponentSize } from 'src/modules/shared/types/component.type';
import type { SearchInputProps } from 'src/modules/shared/types/search-input.types';

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onSearch,
  // TODO: check when implementing i18n
  placeholder = 'Buscar...',
  size = 'md',
  variant = 'primary',
  className = '',
  inputClassName = '',
  'aria-label': ariaLabel,
  error,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch?.();
    }
  };

  const baseClasses = [
    'flex',
    'items-center',
    'w-full',
    'max-w-md',
    className,
  ].join(' ');

  const iconSizeClasses: Record<ComponentSize, string> = {
    lg: 'h-5 w-5',
    md: 'h-4 w-4',
    sm: 'h-4 w-4',
    xs: 'h-3 w-3',
    '2xs': 'h-3 w-3',
  };

  return (
    <div className={baseClasses}>
      <div className="relative flex-1">
        <TextInput
          type={onSearch ? 'text' : 'search'}
          aria-label={ariaLabel ?? placeholder}
          variant={variant}
          size={size}
          error={error}
          className={`${onSearch ? 'rounded-r-none border-r-0' : ''} ${inputClassName}`}
          leadingIcon={
            !onSearch ? (
              <MagnifyingGlassIcon className={iconSizeClasses[size]} />
            ) : undefined
          }
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
        />
      </div>
      {onSearch && (
        <Button
          type="button"
          aria-label={ariaLabel ?? placeholder}
          variant={variant}
          size={size}
          onClick={onSearch}
          className="shrink-0 rounded-l-none"
        >
          <MagnifyingGlassIcon aria-hidden className={iconSizeClasses[size]} />
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
